import UserInteractions from './UserInteractions';

export default UserInteractions;
